// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"1a9221b5","204":"293f4197","228":"28b5e3d9","537":"0662d366","698":"fd7f1250","720":"7abffac7","880":"30b275a3"}[chunkId] + ".chunk.js";
};